<img
    class="p-icon"
    [src]="iconPath"
    [pStyle]="{
        component: {
            width: ['icon', 'size', size],
            height: ['icon', 'size', size]
        }
    }"
/>
